import kernelApi from '@/services/axios/api.kernel';
import DadosLocais from '@/services/helper/storage';
import toastService from '@/services/globals/toast.service';

const dadosLocais = DadosLocais.getInstance();

interface RenovarTokenOutput {
  // undefined em produção (Fase 4: sem token no corpo pra sessão web, a propriedade nem existe
  // no JSON) — só vem preenchido no cenário de dev local.
  accessToken?: string;
  ttlMinutos: number;
}

class TokenRenewalService {
  /**
   * Chama a Kernel API pra emitir um token novo (sem pedir senha de novo), refletindo o TTL do
   * grupo informado. Usado tanto na renovação silenciosa em caso de 401 quanto na troca de grupo.
   */
  async renovar(codigoGrupoUsuario?: number | null, notificar = true): Promise<string | undefined> {
    const { data } = await kernelApi.post<RenovarTokenOutput>('/Users/RenovarToken', {
      codigoGrupoUsuario: codigoGrupoUsuario ?? null,
    });

    dadosLocais.setAccessToken(data.accessToken);

    // Não sobrepõe um toast acionável já na tela (ex: o aviso de encerramento de sessão por
    // inatividade, com o botão "Renovar Minha Sessão") com esta notificação meramente informativa
    // — a renovação do token já aconteceu de qualquer forma, com ou sem o aviso visual.
    if (notificar && !toastService.existeAlertaAtivo()) {
      toastService.alertaSucesso('Sua sessão foi renovada automaticamente.');
    }

    return data.accessToken;
  }
}

export default new TokenRenewalService();
